<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >

                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            :max-date="model.dataFinal ? handleDataFinal() : additionals.dataAtual"
                            :validations="validations.dataInicial"
                            label="Data inicial"
                            right
                            v-model="model.dataInicial"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-time-picker
                            :validations="validations.horarioInicial"
                            label="Horário inicial"
                            v-model="model.horarioInicial"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-date-picker
                            :max-date="additionals.dataAtual"
                            :validations="validations.dataFinal"
                            label="Data final"
                            :min-date="handleDataInicial()"
                            v-model="model.dataFinal"
                            :disabled="!model.dataInicial"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-time-picker
                            :validations="validations.horarioFinal"
                            label="Horário final"
                            v-model="model.horarioFinal"
                            :disabled="!model.horarioInicial"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="unidadeChange()"
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.unidades)"
                            defaultOptionText="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.unidadeId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="infraestruturaChange()"
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.infraestruturas)"
                            defaultOptionText="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="ocupacaoSolicitanteChange()"
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.ocupacoesSolicitante)"
                            defaultOptionText="Todos"
                            label="CBO do profissional solicitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoSolicitanteId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="usuarioSolicitanteChange()"
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.usuariosSolicitante)"
                            defaultOptionText="Todos"
                            label="Profissional solicitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioSolicitanteId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="ocupacaoExecutanteChange()"
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.ocupacoesExecutante)"
                            defaultOptionText="Todos"
                            label="CBO do profissional executante"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoExecutanteId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="usuarioExecutanteChange()"
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.usuariosExecutante)"
                            defaultOptionText="Todos"
                            label="Profissional executante"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioExecutanteId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="exameChange()"
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.exames)"
                            defaultOptionText="Todos"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            @change="statusChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.statusId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            @change="encaminhadoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.encaminhado"
                            default-option-text="Todos"
                            label="Encaminhado"
                            show-default-option
                            text-field="text"
                            v-model="model.encaminhado"
                            value-field="value"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="sortName(form.pacientes)"
                            defaultOptionText="Todos"
                            label="Paciente"
                            show-default-option
                            text-field="nome"
                            v-model="model.pacienteId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            label="Prontuário"
                            v-model="model.prontuario"
                            :disabled="!isPeriodoFill"
                            number
                        />
                    </rkm-col>

                    <rkm-col
                        class="text-nowrap"
                        cols="auto"
                    >
                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="items"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>
                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items && items.length === 0"
                    @click="print()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items && items.length === 0"
                    @click="exportTo()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                class="mt-4"
                :fields="fields"
                :items="items ? items : []"
                sort-by="atendidoEm"
                :sort-desc=true
                :sort-compare="sortCompare"
            />
        </rkm-area>

        <rkm-area
            title="Quantidade total de procedimentos"
            no-margin-top
            class="mt-2"
            v-if="total"
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-alert color="secondary">
                        <strong>
                            {{ total }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

// Mixins.
import { repository, error, data, object, stringCase, formats } from '@/mixins'

// Filters.
import format from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                dataInicial: { required: true },
                dataFinal: { required: true, min_date: this.model.dateDe },
                horarioFinal: {
                    required: true,
                    min_hour: this.getFormatedDate(this.model.dataInicial, 'YYYY-MM-DD') === this.getFormatedDate(this.model.dataFinal, 'YYYY-MM-DD')
                        ? this.getMinHour() : false
                },

            }
        },
        isPeriodoFill() {
            return this.model.dataInicial != null && this.model.dataFinal != null
        }
    },
    created() {

        this.repositories = {
            relatorioExameImagem: this.getConectaSusRepository('prontoAtendimento.relatorioExameImagem'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
            export: this.getConectaSusRepository('exportacao.prontoAtendimento'),
        }

        this.load()
    },
    data: () => ({
        quantidadeTotal: 0,
        items: null,
        model: null,
        total: null,
        form: null,
        additionals: null,
        indeterminate: false,
        filterDefault: {},
        selectedAll: false,
        columns: [
            { key: 'atendidoEm', label: 'Data do atendimento', class: 'col-min text-center', sortable: true, fixed: true },
            { key: 'pacienteNome', label: 'Paciente', sortable: true, fixed: true  },
            { key: 'pacienteDataNascimento', label: 'Data de nascimento', class: 'col-min text-center', sortable: true, fixed: true },
            { key: 'pacienteProntuario', label: 'Prontuário', class: 'col-min text-center', sortable: true, fixed: true },
            { key: 'pacienteCpf', label: 'CPF', class: 'col-min text-center', sortable: true, filterByFormatted: true },
            { key: 'pacienteEnderecoCompleto', label:'Endereço', class: 'col-min text-center', sortable: true },
            { key: 'ocupacaoExecutante', label: 'CBO executante', sortable: true },
            { key: 'profissionalExecutanteNome', label: 'Profissional executante', sortable: true },
            { key: 'exameNome', label: 'Exame', sortable: true },
            { key: 'procedimento', label: 'Procedimento', sortable: true },
            { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center', sortable: true },
            { key: 'statusNome', label: 'Status', class: 'col-min text-center' },
            { key: 'encaminhado', label: 'Encaminhado', class: 'col-min text-center' },
            { key: 'ocupacaoSolicitante', label: 'CBO solicitante', sortable: true },
            { key: 'profissionalSolicitanteNome', label: 'Profissional solicitante', sortable: true },
            { key: 'dataAtendimento', label: 'Data do registro', class: 'col-min text-center', sortable: true },
        ],
        selectedCols: [],
        fieldMap: [
            'data',
            'unidadeId',
            'infraestruturaId',
            'ocupacaoSolicitanteId',
            'usuarioSolicitanteId',
            'ocupacaoExecutanteId',
            'usuarioExecutanteId',
            'exameId',
            'statusId',
            'encaminhado',
            'pacienteId',
        ],
        optionsMap: [
            'data',
            'unidades',
            'infraestruturas',
            'ocupacoesSolicitante',
            'usuariosSolicitante',
            'ocupacoesExecutante',
            'usuariosExecutante',
            'exames',
            'status',
            'encaminhado',
            'pacientes',
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'dataAtendimento') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        handleSelectedColumns(selected) {

            if (selected) {

                this.cols.map(col => {

                    this.selectedCols.push(col.value)
                })

            } else {

                this.selectedCols = []
            }
        },
        load() {

            this.setLoading()

            this.repositories.relatorioExameImagem.list()
                .then(({ data }) => {

                    this.form = this.clone(data.form)
                    this.model = this.clone(data.model)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.setDefaultValues()
                    this.addWatchers()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getPeriodo() {

            this.setFields('data')
            this.setOptions('data')

            const filter = this.getFilter(null)

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = null
                    this.total = null

                    this.repositories.relatorioExameImagem.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data.atendimentos
                            this.total = data.totalizadores.total
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        unidadeChange() {

            this.setFields('unidadeId')
            this.setOptions('unidades')

            const filter = this.getFilter('unidades')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'unidades')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        infraestruturaChange() {

            this.setFields('infraestruturaId')
            this.setOptions('infraestruturas')

            const filter = this.getFilter('infraestruturas')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'infraestruturas')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        ocupacaoSolicitanteChange() {

            this.setFields('ocupacaoSolicitanteId')
            this.setOptions('ocupacoesSolicitante')

            const filter = this.getFilter('ocupacoesSolicitante')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'ocupacoesSolicitante')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        ocupacaoExecutanteChange() {

            this.setFields('ocupacaoExecutanteId')
            this.setOptions('ocupacoesExecutante')

            const filter = this.getFilter('ocupacoesExecutante')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'ocupacoesExecutante')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        usuarioExecutanteChange() {

            this.setFields('usuarioExecutanteId')
            this.setOptions('usuariosExecutante')

            const filter = this.getFilter('usuariosExecutante')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'usuariosExecutante')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        usuarioSolicitanteChange() {

            this.setFields('usuarioSolicitanteId')
            this.setOptions('usuariosSolicitante')

            const filter = this.getFilter('usuariosSolicitante')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'usuariosSolicitante')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        exameChange() {

            this.setFields('exameId')
            this.setOptions('exames')

            const filter = this.getFilter('exames')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'exames')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        statusChange() {

            this.setFields('statusId')
            this.setOptions('status')

            const filter = this.getFilter('status')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'status')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        encaminhadoChange() {

            this.setFields('encaminhado')
            this.setOptions('encaminhado')

            const filter = this.getFilter('encaminhado')

            if (filter) {

                this.setLoading()

                this.repositories.relatorioExameImagem.list(filter)
                    .then(({ data }) => {

                        this.cloneFields(data, 'encaminhado')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        print() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.impressao.relatorioExameImagem(this.prepareDataWithColumns())
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        exportTo() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.export.exportExameImagem(this.prepareDataWithColumns())
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model);

            const unidade = this.form.unidades && Object.values(this.form.unidades).find(u => u.id === data.unidadeId);
            data.unidade = unidade ? unidade.nome : 'Todas';

            const infraestrutura = this.form.infraestruturas
                && Object.values(this.form.infraestruturas).find(l => l.id === data.infraestruturaId);
            data.infraestrutura = infraestrutura ? infraestrutura.nome : 'Todos';

            const ocupacaoSolicitante = this.form.ocupacoesSolicitante
                && Object.values(this.form.ocupacoesSolicitante).find(o => o.id === data.ocupacaoSolicitanteId);
            data.ocupacaoSolicitante = ocupacaoSolicitante ? ocupacaoSolicitante.nome : 'Todos';

            const ocupacaoExecutante = this.form.ocupacoesExecutante
                && Object.values(this.form.ocupacoesExecutante).find(o => o.id === data.ocupacaoExecutanteId);
            data.ocupacaoExecutante = ocupacaoExecutante ? ocupacaoExecutante.nome : 'Todos';

            const exame = this.form.exames && Object.values(this.form.exames).find(p => p.id === data.exameId);
            data.exame = exame ? exame.nome : 'Todos';

            const status = this.form.status && Object.values(this.form.status).find(s => s.id == data.statusId);
            data.status_nome = status ? status.nome : 'Todos';

            const usuarioSolicitante = this.form.usuariosSolicitante
                && Object.values(this.form.usuariosSolicitante).find(s => s.id == data.usuarioSolicitanteId);
            data.usuarioSolicitante = usuarioSolicitante ? usuarioSolicitante.nome : 'Todos';

            const usuarioExecutante = this.form.usuariosExecutante
                && Object.values(this.form.usuariosExecutante).find(s => s.id == data.usuarioExecutanteId);
            data.usuarioExecutante = usuarioExecutante ? usuarioExecutante.nome : 'Todos';

            data.encaminhado_text = data.encaminhado === true ? 'SIM' : data.encaminhado === false ? 'NÃO' : 'Todos'

            const paciente = this.form.pacientes && Object.values(this.form.pacientes).find(s => s.id == data.pacienteId);
            data.paciente = paciente ? paciente.nome : 'Todos';

            this.formateDates(data, ['dataInicial', 'dataFinal'], 'DD/MM/YYYY');

            return this.camelObjectKeysToSnakeRecursive(data);
        },
        getFilter(field) {

            if (this.isPeriodoFill) {

                const filter = this.clone(this.model)

                if (field) {
                    filter.loadFrom = field
                }

                this.formateDates(filter, ['dataInicial', 'dataFinal'], 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        download(response) {

            const content = new Blob([response.data], {type: response.headers['content-type']})
            const url = URL.createObjectURL(content)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        resetForm() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.total = null

            this.setDefaultValues()

            this.$refs.RkmForm.resetValidator()
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleDataInicial() {

            return this.model.dataInicial ? moment(this.model.dataInicial).format('DD/MM/YYYY') : ''
        },
        handleDataFinal() {

            return this.model.dataFinal ? moment(this.model.dataFinal).format('DD/MM/YYYY') : ''
        },
        getMinHour() {

            const horario = this.model.horarioInicial

            if (horario) {

                return moment(horario, 'HH:mm').add(1, 'minutes').format('HH:mm')
            }

            return false
        },
        setFields(value) {

            const index = this.fieldMap.indexOf(value) + 1;

            for (let i = index; i < this.fieldMap.length; i++) {

                const field = this.fieldMap[i];

                if (this.model[field] !== null) {

                    for (const ref of Object.values(this.$refs)) {

                        if (ref.validate) {
                            ref.resetValidator();
                        }
                    }

                    this.$set(this.model, field, null);
                }
            }
        },
        setOptions(value) {

            const index = this.optionsMap.indexOf(value) + 1;

            for (let i = index; i < this.optionsMap.length; i++) {

                const option = this.optionsMap[i];
                this.$set(this.form, option, []);
            }

            this.items = null
            this.total = null
        },
        cloneFields(data, value) {

            const index = this.optionsMap.indexOf(value) + 1;

            for (let i = index; i < this.optionsMap.length; i++) {

                const option = this.optionsMap[i];
                const fieldValue = data.form[option];

                if (typeof fieldValue === 'object') {
                    this.form[option] = this.clone(fieldValue);
                } else {
                    this.form[option] = this.clone(fieldValue);
                }
            }
        },
        setDefaultValues() {

            this.model.dataInicial = moment(this.additionals.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.dataFinal = moment(this.additionals.dataAtual, 'DD/MM/YYYY').toDate()
        },
        addWatchers() {

            this.addWatcherDataInicial()
            this.addWatcherDataFinal()
        },
        addWatcherDataInicial() {

            this.$watch('model.dataInicial', function (dataInicial) {

                if (!dataInicial) {
                    this.model.dataFinal = null
                }

                if (this.model.dataFinal) {
                    this.getPeriodo()
                }
            })
        },
        addWatcherDataFinal() {

            this.$watch('model.dataFinal', function (dataFinal) {

                if (dataFinal) {

                    this.getPeriodo()
                }
            })
        },
        sortName(fields) {

            if (typeof fields === 'object') {

                const objectArray = Object.keys(fields).map(key => fields[key]);

                if (objectArray.length > 0) {
                    objectArray.sort((a, b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
                    return objectArray;
                }
            }

            return [];
        }
    },
    filters: {
        ...format,
    },
    mixins: [ repository, error, data, object, stringCase, formats ],
    watch: {
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
        'model.horarioInicial': function (horarioInicial) {

            if (!horarioInicial) {

                this.model.horarioFinal = null
            }

            if (this.model.horarioFinal) {

                this.getPeriodo()
            }
        },
        'model.horarioFinal': function (horarioFinal) {

            if (horarioFinal) {

                this.getPeriodo()
            }
        },
    }
}
</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }
    .dropdown >>> .auto-scroll {
        max-height: 300px;
        overflow: auto;
    }
</style>